export const companyDatas = [
    {
        name: "Feeding America",
        desc: "Feeding America is a United States based nonprofit organization that is a nationwide network of more than 200 food banks that feed more than 46 million people through food pantries, soup kitchens, shelters, and other community-based agencies.",
        founder: "ohn van Hengel",
        type: "Non-Profit",
        website: "feedingamerica.org",
        requiredFood: 100,
        donatedFood: 98,
        dueDate: "29, Feb, 2023",
        imgURL: "https://static.wixstatic.com/media/8e94e4_b015ff0396af4258a2bcd3f46d2f57cd~mv2.png/v1/fill/w_1080,h_1080,al_c/8e94e4_b015ff0396af4258a2bcd3f46d2f57cd~mv2.png"
    },
    {
        name: "Capital Area Food Bank Inc",
        desc: "The Capital Area Food Bank is the largest organization in the Washington metro area working to solve hunger and its companion problems: chronic undernutrition, heart disease, diabetes, and obesity.",
        founder: "Lynn Brantley",
        type: "Non-Profit",
        website: "	capitalareafoodbank.org",
        requiredFood: 80,
        donatedFood: 55,
        dueDate: "23, May, 2023",
        imgURL: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFAJmdZBwyc7KN1b1DIuEjSIp9Z6CDCwuXJTm_7kc&usqp=CAE&s"
    },
    {
        name: "North Texas Food Bank",
        desc: "The North Texas Food Bank (NTFB) is a social benefit organization located in Plano, Texas. The organization distributes donated, purchased and prepared foods through a network of nearly 1,000 feeding programs and 400 Partner Agencies in 13 North Texas counties.",
        founder: "Liz Minyard, Kathryn Walt Hall, Jo Curtis and Lorraine Griffin Kircher",
        type: "Non-Profit",
        website: "www.ntfb.org",
        requiredFood: 60,
        donatedFood: 22,
        dueDate: "10, March, 2023",
        imgURL: "https://boodle.ai/wp-content/uploads/2020/10/1200x628-ntfb-header-150-01.png"
    },
    {
        name: "Houston Food Bank",
        desc: "The Houston Food Bank (HFB) is a non-profit organization and the nation's largest food bank by distribution; providing access to 207 million nutritious meals in 18 counties in southeast Texas.",
        founder: "Stanford Alexander, Joan Alexander, Bert Bandini",
        type: "Non-Profit",
        website: "	www.houstonfoodbank.org",
        requiredFood: 80,
        donatedFood: 42,
        dueDate: "14, December, 2023",
        imgURL: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Houston_Food_Bank_%28logo%29.jpg/310px-Houston_Food_Bank_%28logo%29.jpg"
    },
    {
        name: "Food Bank For NYC",
        desc: "Food Bank For New York City is a non-profit social services organization and the major hunger-relief organization working against hunger in the five boroughs.",
        founder: "Kathy Goldman",
        type: "Non-Profit",
        website: "https://www.foodbanknyc.org/",
        requiredFood: 100,
        donatedFood: 22,
        dueDate: "3, November, 2023",
        imgURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAqCAMAAADRRmi8AAAAb1BMVEX////ydCDxZwD96uLxaQD84tbxbADychn++PXxZQDxYQD85Nn//Prybgj2o3rwWgD1m23+8+/3q4f72sv4vaL0kl7608H0iEz2pn/6zLj5xq797+j3tZXzfDPzg0P1lmXzeSv3sI70jlbwUgDzgDugwfShAAADIElEQVRIieWU65LjKAxGhS/IxgaDwWAwvo7f/xkXJ+lJdqe7sj01f7ZWlcQqxEH6cCSA/4epvh8VmDUm38u+gtD34Qqkp06P0advDq1QPoAxTzBnUrYjW+sVQjfgBoIcbEgBuYguh5IhQH1C+2MSQv1oXsAOoO0slN2EESpmRZ/W0ga5AyuhH7IcaBahm8bxEC+l5vVGNEsODSxtd2bsAXgqVnK+ARTaGcgiK9nUE6ZeQRZ801WpHpsSwHwD6yRMSr3FhpWjA5YLkk2jJOMr2LUA2QiRgXOt73Ih2ngdLXsYRORkq6u6BEzgaLt/aISyyDILimR1hJHWyQcQnBYlJo/6JLNhqhcwzK+l4oaEcDpvM3KcMbl4bojIC5xrQkiKIs7FRvlGLjUfoLA82DXqgZNcymBmYwPnMYjo90PvoxHIg5/9VhrnjX6CvafahdgcuFklbV+X1lOSNUxzPeR9Py1YlDzdfFgyTV8yLicehq/nimRdFmn4sTkkKPkZ5sWJ4xwRXdgEX2eUxQuYZCBPKm5S8HIvVdcvx7vdN9y0voIZ+cwK/Hz5HYjKfUq+A1FCz78D0kcabiB+B0R93LdTDYF+J2PqjhtZK7A/QUrfgjQ1+HKReP19H2vcP8/4MmORuuJMb+z4WOephV/lfgVimhnthjy1ZMXSAbVIJ4nivUZSpA5uKc6p7+LCXJ4OWG6F4hcgFpTfYrSFifKMXKHp6lR+67lsmT8F8Zh8f9YJxkXQzFTbI2pq5BkXtnrc8i/gcrmtjo5nG0QD8gNkzlzjQvX0i1JpvE8w12xVdcJtKqVhBNXllGvGf9XYZZfVrDvsNUhAC6gXdrjo7t1eGexY9rDuCf62VcMzuY/P9f0d6BeQEezQgJBBjhGCMPkuYC11EDa0Vpk11efXyUe17tNPsDFCGT+k2a+1kW20EpxNs2te4WiX0gzlDgrUCm6sHOxPjU00YW2cHey+m9UPubOntaYZ5HTAApudBqu1claKtg/Hc5RXOdgGlG9Bl1OuG5hso9RUNVCmD7hLelu2ykMDNroJ/p1Vf7v+KvyBt/Ffsb8AGEc4V5cUDHcAAAAASUVORK5CYII="
    }
];

export const banks = [
    {
        image: "https://static.wixstatic.com/media/8e94e4_b015ff0396af4258a2bcd3f46d2f57cd~mv2.png/v1/fill/w_1080,h_1080,al_c/8e94e4_b015ff0396af4258a2bcd3f46d2f57cd~mv2.png",
        name: 'Feeding America',
        status: 'Pending',
        button: 'Summary'
    },
    {
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFAJmdZBwyc7KN1b1DIuEjSIp9Z6CDCwuXJTm_7kc&usqp=CAE&s",
        name: 'Capital Area Food Bank Inc',
        status: 'Accepted',
        button: 'Track'
    },
    {
        image: "https://boodle.ai/wp-content/uploads/2020/10/1200x628-ntfb-header-150-01.png",
        name: 'North Texas Food Bank',
        status: 'Declined',
        button: 'Reason'
    },
    {
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Houston_Food_Bank_%28logo%29.jpg/310px-Houston_Food_Bank_%28logo%29.jpg",
        name: 'Houston Food Bank',
        status: 'Delivered',
        button: 'Summary'
    }
];

export const providers = [
    // {
    //     image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fHBlb3BsZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=1200&q=60',
    //     name: 'Abhishek Gaire',
    //     status: 'Pending',
    //     button: 'Pending'
    // },
    {
        image: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mjl8fHBlb3BsZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=1200&q=60',
        name: 'Sije Park',
        status: 'Delivering',
        button: 'Track'
    },
    {
        image: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjZ8fHBlb3BsZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=1200&q=60',
        name: 'Seungjun Chae',
        status: 'Delivered',
        button: 'Summary'
    }
];

export const restaurants=[
    {
        image: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjZ8fHBlb3BsZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=1200&q=60',
        name: '2023 February 12 10:30 AM',
        status: 'Pending',
        button: '30'
    },{
        image: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mjl8fHBlb3BsZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=1200&q=60',
        name: '2023 February 11 12:30 AM',
        status: 'Pending',
        button: '40'
    },{
        image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fHBlb3BsZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=1200&q=60',
        name: '2023 February 10 9:00 AM',
        status: 'Pending',
        button: '30'
    },
]